export default {
  manual: 'Manuel',
  buyPoints: 'Point purchase',
  pointPayment: 'Paid with points',
  refundForResourceBookingAddedSubscriptionPayment: 'Added attendee with subscription',
  paymentRefunded: 'Refunded payment',
  automaticPoints: 'Auto points'
}